// extracted by mini-css-extract-plugin
export default {"icon":"poster-item-controls-module__icon--Ln9ZH","deleteIcon":"poster-item-controls-module__deleteIcon--N74TE"};